import { BaseSection } from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/section-views/BaseSection.ts';
import { MODE } from '@services/MarppleShopStudio/widget/CreatorProduct/core/types/types.ts';
import { createCreatorProductStore } from '@services/MarppleShopStudio/widget/CreatorProduct/core/store/createStore.ts';
import { html, View } from 'rune-ts';
import { formKeyMap } from '@services/MarppleShopStudio/widget/CreatorProduct/core/zod-schema/shared.ts';
import { Input_NumberEditor } from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/input-views/Input_NumberEditor.ts';
import { MAX_PURCHASE_PER_USER__MAX } from '@services/MarppleShopStudio/widget/CreatorProduct/core/zod-schema/constants.ts';
import klass from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/section-views/styles/color.module.scss';
import { font } from '@services/MarppleShop/shared/typography';

import { EditorInputFocusoutEvent } from '@services/MarppleShopStudio/shared/component/atom/Input/core/events.ts';
import { Input_SpoTextOptions } from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/input-views/Input_SpoTextOptions.ts';

interface ProducingInfoSectionData<T extends MODE> {
  store: ReturnType<typeof createCreatorProductStore<T>>;
}

export class ProducingInfoSection<T extends MODE> extends BaseSection<T, ProducingInfoSectionData<T>> {
  protected readonly sectionTitle = '제작 정보';
  private store = this.data.store;

  private inputMap = {
    [formKeyMap.max_days]: new Input_NumberEditor({
      name: formKeyMap.max_days,
      value: this.store.formData.max_purchase_per_user ?? null,
      title: '최대 제작소요기간',
      option: {
        placeholder: '최대 제작소요기간을 입력해 주세요.',
        max: MAX_PURCHASE_PER_USER__MAX,
        right_html: html`<div class="${klass.gray_80} ${font('14_medium')}">일</div>`,
      },
    }),
    [formKeyMap.spo_text_options]: new Input_SpoTextOptions({
      name: formKeyMap.spo_text_options,
      value: this.store.formData._.product._.spo._.spo_text_options,
      title: '제작요청사항',
      setField: this.store.actions.setField,
    }),
  };

  protected override inputViews(): Array<View> {
    return [this.inputMap.max_days, this.inputMap.spo_text_options];
  }

  override onRender() {
    this.addEventListener(EditorInputFocusoutEvent, (e) => {
      switch (e.detail.name) {
        case formKeyMap.max_days: {
          this.store.actions.setField(formKeyMap.max_days, this.inputMap[e.detail.name].getNumericValue());
          break;
        }
      }
    });
  }
}
